/***
 * Copyright (c) Myia 2023-2025 - All Rights Reserved
 */
import { ClerkProvider, RedirectToSignIn, SignedIn, SignedOut } from '@clerk/clerk-react';
import * as Sentry from '@sentry/react';
import ReactDOM from 'react-dom/client';

import App from './App';

import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';
import '@fontsource/teko/300.css';
import '@fontsource/teko/400.css';
import '@fontsource/teko/500.css';
import '@fontsource/teko/700.css';
import '@fontsource/source-sans-pro/300.css';
import '@fontsource/source-sans-pro/400.css';
import '@fontsource/source-sans-pro/700.css';
import './index.css';

const replay = Sentry.replayIntegration({
    maskAllText: false,
    blockAllMedia: false,
});

const PUBLISHABLE_KEY = import.meta.env.VITE_CLERK_PUBLISHABLE_KEY;
if (!PUBLISHABLE_KEY) alert('Please set Clerk env vars in front/.env');

process.env.NODE_ENV !== 'development' &&
    Sentry.init({
        environment: process.env.NODE_ENV,
        dsn: import.meta.env.VITE_SENTRY_ENDPOINT,
        // Performance Monitoring
        tracesSampleRate: 1.0, //  Capture 100% of the transactions
        // Set sampling rate for profiling - this is relative to tracesSampleRate
        profilesSampleRate: 1.0,
        ignoreErrors: [
            "Failed to execute 'insertBefore' on 'Node': parameter 1 is not of type 'Node'.",
            "Failed to execute 'insertBefore' on 'Node': This node type does not support this method.",
        ],
        //Replay is only started when the user is not from Heal, see in App.tsx
        integrations: [replay],
        // Session Replay
        // This sets the sample rate at 10%. You may want to change it to 100%
        // while in development and then sample at a lower rate in production.
        replaysSessionSampleRate: 0,
        // If you're not already sampling the entire session, change the sample rate
        // to 100% when sampling sessions where errors occur.
        replaysOnErrorSampleRate: 0,
    });

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <ClerkProvider publishableKey={PUBLISHABLE_KEY} afterSignOutUrl="https://heal.dev">
        <SignedIn>
            <App />
        </SignedIn>
        <SignedOut>
            <RedirectToSignIn />
        </SignedOut>
    </ClerkProvider>,
);
